import { FilterValueBaseInterface } from '../value-base.interface';
import { filterDefaultParamsCommon } from './common';

export const defaultFilterParamsAE: FilterValueBaseInterface = {
  ...filterDefaultParamsCommon,
};
